// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
import { SizeMap } from './has-size.contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const getSizePropDefinition = (defaultSize = SizeMap.Medium) => {
    return {
        type: String,
        required: false,
        default: defaultSize
    };
};
/**
 * Props partial.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const hasSizeProp = {
    size: getSizePropDefinition()
};
/**
 * @param size - Component's `size` reactive reference.
 * @param sizeClassRegistry - registry that should be used
 *  to determine the applicable CSS class.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const useSizeClass = (size, sizeClassRegistry) => {
    /**
     * The CSS class specifying the input's sizing variant.
     */
    return computed(() => {
        if (typeof sizeClassRegistry[size.value] !== 'string') {
            if (!Object.keys(sizeClassRegistry).length) {
                console.warn('useSizeClass(): Provided registry does NOT contain any definition. Used no class.');
            }
            console.warn(`useSizeClass(): Provided registry does NOT contain the given key.\nFalling back to the first key in the set, which is [${Object.keys(sizeClassRegistry)[0]}].`);
            return Object.values(sizeClassRegistry)[0];
        }
        return sizeClassRegistry[size.value];
    });
};
